import { Fragment } from "react"
import { CancelButton, Card, CommandButton } from "components"
import type { CommandType } from "types"

type FooterMenuProps = {
  hasCancelButton?: boolean
  attachment?: CommandType
  customRightElement?: JSX.Element
  printRight?: boolean
  customElement?: {
    attachment?: JSX.Element
    delete?: JSX.Element
    email?: JSX.Element
    export?: JSX.Element
    journal?: JSX.Element
    print?: JSX.Element
    save?: JSX.Element
    pdf?: JSX.Element
  }
  delete?: CommandType
  email?: CommandType
  export?: CommandType
  pdf?: CommandType
  journal?: CommandType
  print?: CommandType
  save?: CommandType
}

export const FooterMenu = (params: FooterMenuProps) => {
  return (
    <Card>
      <Card.Body className="flex flex-col gap-5">
        <section className="flex flex-wrap justify-between items-center gap-3">
          <section className="flex flex-wrap gap-3">
            {params.customElement?.print && !params?.printRight ? params.customElement.print : params.print && !params?.printRight && <CommandButton {...params.print} actiontype="print" />}
            {params.customElement?.email ? params.customElement.email : params.email && <CommandButton {...params.email} actiontype="email" />}
            {params.customElement?.export ? params.customElement.export : params.export && <CommandButton {...params.export} actiontype="export" />}
            {params.customElement?.pdf ? params.customElement.pdf : params.pdf && <CommandButton {...params.pdf} actiontype="pdf" />}
            {params.customElement?.journal ? params.customElement.journal : params.journal && <CommandButton {...params.journal} actiontype="journal" />}
            {params.customElement?.attachment ? params.customElement.attachment : params.attachment && <CommandButton {...params.attachment} actiontype="attachment" />}
          </section>

          <section className="flex flex-wrap gap-3">
            {params.customRightElement ?? (
              <Fragment>
                {params.hasCancelButton && <CancelButton />}
                {params.customElement?.delete ? params.customElement.delete : params.delete && <CommandButton {...params.delete} actiontype="delete" />}
                {params.customElement?.save ? params.customElement.save : params.save && <CommandButton {...params.save} actiontype="save" />}
                {params.customElement?.print && params?.printRight ? params.customElement.print : params.print && params?.printRight && <CommandButton {...params.print} actiontype="print" />}
              </Fragment>
            )}
          </section>
        </section>
      </Card.Body>
    </Card>
  )
}